import { Text as WalrusText } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewText = styled(WalrusText)`
  color: ${newBrandDesignVars.grey4};
  margin-top: 0;
`;

export default NewText;
